import UserData from './components/UserData/index.vue';
import UserContact from './components/UserContact/index.vue';
import UserLanguage from './components/UserLanguage/index.vue';
import { mapGetters } from 'vuex';
import userChangePassword from '@/modules/Profile/pages/user-info/components/UserChangePassword/index.vue';
import UserInfoHeader from './components/UserInfoHeader/index.vue';
import { globalLoader } from '@/helpers/variables';

export default {
  name: 'UserInfo',
  components: {
    UserInfoHeader,
    UserData,
    UserContact,
    UserLanguage,
    userChangePassword
  },
  created() {},
  mounted() {
    globalLoader(false);
  },
  computed: {
    ...mapGetters({
      user: 'profile/user'
    })
  },
  methods: {}
};
